import EntityExportHandler from 'common/entity/generic/EntityExportHandler';
import { orderMasterExport as orderMasterExportApi } from 'common/middleware/api';

export default class OrderMasterExportHandler extends EntityExportHandler {
    constructor() {
        super();
        this.exportApi = orderMasterExportApi;
    }
}
